/**
 * The gold action button of the game views (LOCK IN · 20s, LOCK PREDICTION · 10s, LOCKED, PREDICTING YOU, NEXT ROUND, FINAL RESULTS): the lobby's own
 * gold CTA — the kit's plate and the action-role word as text, one element (owner 23.9.2026: "vanhaa roskaa … meillähän oli jossain tuollainen
 * kultainen button jo"). While it cannot be pressed the plate wears the room's colour (CSS .cta-plate.off per theme) with the word in white;
 * pressable = the plain gold plate with the dark word (owner 24.9.2026). Box: the kit's tube where the old plate's was (110,1369 718×110).
 */
import { KitButton, KitPiece, KitText, type KitTx } from './LobbyKit';

export const CTA_PLATE = { id: 'cta.plate', piece: 'cta.plate.png', render: '3-slice' as const, tint: 'none', z: 30, slicePx: { left: 331, right: 331, top: 0, bottom: 0 }, x: 92, y: 1351, w: 754, h: 147 };
export const CTA_WORD: KitTx = { id: 'cta.label', text: '', role: 'action', className: 't-action on-gold', x: 130, y: 1391, w: 680, h: 70, maxW: 680, align: 'center', overflow: 'visible', size: 44 };   // the word 2 down (owner 23.9.2026)

export function Action({ label, off, onClick, testid, y }: { label: string; off: boolean; onClick?: () => void; testid: string; /** another vertical place (the round result's NEXT) */ y?: number }) {
  const plate = y === undefined ? CTA_PLATE : { ...CTA_PLATE, y }; const word = y === undefined ? CTA_WORD : { ...CTA_WORD, y: CTA_WORD.y + (y - CTA_PLATE.y) };
  return (
    <KitButton plate={plate} testid={testid} label={label} off={off} onClick={onClick}>
      <KitPiece e={plate} cls={`bd-kit cta-plate${off ? ' off' : ''}`} />
      <KitText t={word} text={label} cls={off ? 'off' : ''} />
    </KitButton>
  );
}
